export enum CATEGORY {
  ARTICLE = '/categories/:id/articles',
}
